<div class="d-flex">
    <molecule-lifecycle-stage-tag
        [lifecycleStage]="data"
    ></molecule-lifecycle-stage-tag>
</div>
